<template>
  <div class="col-md-12 instance_group">
    <div
      :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
      @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="filters" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="form_select"></div>
      <div class="form_select"></div>
      <div class="form_select"></div>
      <div class="form_select"></div>
      <div class="form_select"></div>
      <div class="form_select">
        <span class="btn btn-success" @click="add_group_instance" >
          <i class="mdi mdi-plus-circle-outline" />{{ translate('group.create') }}
        </span>
      </div>
    </div>

    <div class="response_table">
      <div class="loading" v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th scope="col">
              {{ translate('server.instance_group.name') }}
            </th>
            <th scope="col" class="text-left">
              {{ translate('server.instance_group.descr') }}
            </th>
            <th scope="col">
              {{ translate('server.instance_group.server') }}
            </th>
            <th scope="col">
              {{ translate('server.instance_group.ip') }}
            </th>
            <th scope="col" class="w100"></th>
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="(group, key) in instances_groups"
              :key="key"
              class="instance_group"
          >
            <td :data-label="translate('server.instance_group.name')">
              {{ group.name }}
            </td>
            <td class="text-left" :data-label="translate('server.instance_group.descr')">
              {{ group.descr }}
            </td>
            <td :data-label="translate('server.instance_group.server')">
              {{ group.server_name }}
            </td>
            <td :data-label="translate('server.instance_group.ip')">
              {{ group.server_ip }}
            </td>
            <td class="w100"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import AddGroupInstance from "./Modal/AddGroupInstance.vue";

export default {
  name: 'InstanceGroups',
  components: {},
  data () {
    return {
      instances_groups: [],
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true
    }
  },
  created () {
    this.get_instances_groups()
  },
  methods: {
    add_group_instance () {
      let t = this.$createElement(AddGroupInstance, {
        on: {
          close: () => {
            this.$modal.hide('add_instance')
          },
          update: () => {
            this.$modal.hide('add_instance')
            this.get_instances_groups()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'add_instance'
      })
    },
    get_instances_groups(){
      this.loading = true
      this.$http.v1.getServerInstanceGroups({}, (response) => {
        this.instances_groups = response.data
        this.loading = false
      })
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state;
      this.localStorage.setItem("filters_state", this.filters_state);
    },
  }

}
</script>

<style lang="scss" scoped>
.instance_group{
  padding-top: 30px;
  &_wrap{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .filters{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    .form_select{
      flex: 1;
    }
    .btn{
      width: 100%;
      padding: 2px 10px;
    }
  }

  .response_table{
    padding: 0;
  }
}
</style>
